import { CircularProgress } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { useAiPrompt } from '../../../../sic-lib/api/hooks/useAiPrompts';
import AiCreateEditPrompt from './AiCreateEditPrompt';

interface Props {
    promptId: number;
}

export default function AiCreateEditPromptContainer({ promptId }: Props) {
    const { classes } = useStyles();

    const { data: prompt, isLoading } = useAiPrompt(promptId);

    if (!Number.isNaN(promptId) && promptId > 0 && isLoading) {
        return <CircularProgress />;
    } else {
        return <AiCreateEditPrompt aiPrompt={prompt} hideBackButton={false} />;
    }
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {},
}));
